/* EDELHOLZ LP "4 Schritte" Regler (28.09.2026), Section edelholz-lp-schritte.liquid.
   Verhalten 1:1 nach mockups/v4-auswahl.html: ein Video zur Zeit, Station 1 startet muted/playsinline sobald
   sichtbar, Ausschnitt start/ende je Station, ruhiges Auto-Weiter bis zum ersten Nutzereingriff, danach loopt der
   gewaehlte Ausschnitt. Ziehen, Tippen, Pfeiltasten. Reduzierte Bewegung: Poster + Play-Knopf.
   Videos bekommen ihr src erst beim Abspielen (preload none bis sichtbar). */
(function () {
  var RM = false;
  try { RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var MOBIL = false;
  try { MOBIL = window.matchMedia('(max-width: 749px)').matches; } catch (e) {}

  function melde(name) {
    try { document.dispatchEvent(new CustomEvent('eh:lp-video', { detail: { chapter: 'Schritt: ' + name } })); } catch (e) {}
  }

  function init(root) {
    if (root.__ehStp) return; root.__ehStp = true;
    var slides = [].slice.call(root.querySelectorAll('.eh-stp__slide'));
    var vids = slides.map(function (s) { return s.querySelector('video'); });
    var sts = [].slice.call(root.querySelectorAll('.eh-stp__st'));
    var caps = [].slice.call(root.querySelectorAll('.eh-stp__cap'));
    var thumb = root.querySelector('.eh-stp__thumb'), rail = root.querySelector('.eh-stp__rail'), fill = root.querySelector('.eh-stp__fill');
    var prog = root.querySelector('.eh-stp__prog i'), cnt = root.querySelector('.eh-stp__count'), pbtn = root.querySelector('.eh-stp__play');
    var N = slides.length, idx = 0, user = false, visible = false, manual = false, gemeldet = {};
    var AUTO = root.getAttribute('data-auto') !== '0';
    var names = sts.map(function (b) { return b.getAttribute('data-name') || ''; });
    if (!N || !thumb || !rail) return;

    function seg(v) { return { s: parseFloat(v.getAttribute('data-start')) || 0, e: parseFloat(v.getAttribute('data-end')) || 0 }; }
    function quelle(v) { return (MOBIL && v.getAttribute('data-src-m')) || v.getAttribute('data-src'); }
    function src(v, pre) {
      if (!v || v.getAttribute('src')) return;
      v.muted = true; v.preload = pre || 'auto';
      v.src = quelle(v) + '#t=' + seg(v).s;
    }
    function allowed() { return !RM || manual; }
    function play(i) {
      var v = vids[i];
      if (!v || !allowed()) return;
      var g = seg(v); src(v, 'auto');
      var go = function () {
        if (i !== idx) return;
        if (v.currentTime < g.s - 0.3 || (g.e && v.currentTime >= g.e)) { try { v.currentTime = g.s; } catch (e) {} }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      };
      if (v.readyState >= 1) go(); else v.addEventListener('loadedmetadata', go, { once: true });
      if (!RM && !user && AUTO && i + 1 < N) src(vids[i + 1], 'metadata');
    }
    function pos(i) { return (i + 0.5) / N * 100; }
    function setUI(i) {
      thumb.style.left = pos(i) + '%';
      fill.style.width = (N > 1 ? i / (N - 1) * 100 : 0) + '%';
      thumb.setAttribute('aria-valuenow', i + 1);
      thumb.setAttribute('aria-valuetext', (i + 1) + ' / ' + N + ': ' + names[i]);
      sts.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.classList.toggle('is-past', k <= i); });
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      caps.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
      if (cnt) cnt.textContent = (i + 1) + ' / ' + N;
      if (prog) prog.style.transform = 'scaleX(0)';
    }
    function goTo(i, byUser) {
      i = Math.max(0, Math.min(N - 1, i));
      if (byUser && !user) { user = true; root.classList.add('is-user'); }
      if (byUser && !gemeldet[i]) { gemeldet[i] = true; melde(names[i]); }
      if (i === idx) { setUI(i); if (visible && vids[i] && vids[i].paused) play(i); return; }
      var prev = idx; idx = i;
      if (vids[prev]) vids[prev].pause();
      setUI(i);
      if (visible) play(i);
    }
    vids.forEach(function (v, k) {
      if (!v) return;
      function atEnd() {
        if (k !== idx) return;
        var g = seg(v);
        if (!user && !RM && AUTO && idx < N - 1) { goTo(idx + 1, false); }
        else { try { v.currentTime = g.s; } catch (e) {} var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      }
      v.addEventListener('timeupdate', function () {
        if (k !== idx) return;
        var g = seg(v);
        if (v.currentTime < g.s - 0.5) { try { v.currentTime = g.s; } catch (e) {} return; }
        if (g.e && v.currentTime >= g.e) { atEnd(); return; }
        if (prog && !user && g.e > g.s) prog.style.transform = 'scaleX(' + Math.max(0, Math.min(1, (v.currentTime - g.s) / (g.e - g.s))) + ')';
      });
      v.addEventListener('ended', atEnd);
    });

    /* Sichtbarkeit: erst ab 35 % im Bild abspielen, ausserhalb pausieren */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var vis = en.isIntersecting && en.intersectionRatio >= 0.35 && !!root.offsetParent;
          visible = vis;
          if (vis) play(idx); else vids.forEach(function (v) { if (v && !v.paused) v.pause(); });
        });
      }, { threshold: [0, 0.35, 0.6] });
      io.observe(root.querySelector('.eh-stp__stage'));
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) vids.forEach(function (v) { if (v && !v.paused) v.pause(); });
      else if (visible) play(idx);
    });

    /* Reduzierte Bewegung: Standbild mit Play-Knopf */
    if (RM && pbtn) {
      pbtn.hidden = false;
      pbtn.addEventListener('click', function () { manual = true; pbtn.hidden = true; visible = true; goTo(idx, true); play(idx); });
    }

    /* Ziehen / Antippen */
    var drag = null, lo = 0.5 / N, hi = 1 - 0.5 / N;
    function frac(x) { var r = rail.getBoundingClientRect(); return Math.max(lo, Math.min(hi, (x - r.left) / r.width)); }
    function near(f) { return Math.round((f - lo) * N); }
    function freigeben() { if (RM && !manual) { manual = true; if (pbtn) pbtn.hidden = true; } }
    rail.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      drag = { id: e.pointerId, x: e.clientX, moved: false, onThumb: e.target === thumb };
      if (drag.onThumb) { try { rail.setPointerCapture(e.pointerId); } catch (_) {} rail.classList.add('is-drag'); e.preventDefault(); }
    });
    rail.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (!drag.moved && Math.abs(e.clientX - drag.x) > 6) {
        drag.moved = true;
        if (!drag.onThumb) { try { rail.setPointerCapture(e.pointerId); } catch (_) {} rail.classList.add('is-drag'); }
      }
      if (drag.moved) {
        var f = frac(e.clientX);
        thumb.style.left = (f * 100) + '%';
        fill.style.width = ((f - lo) / (hi - lo) * 100) + '%';
        var n = near(f);
        sts.forEach(function (b, k) { b.classList.toggle('is-on', k === n); });
      }
    });
    function end(e) {
      if (!drag || e.pointerId !== drag.id) return;
      drag = null; rail.classList.remove('is-drag');
      if (e.type === 'pointercancel') { setUI(idx); return; }
      freigeben();
      goTo(near(frac(e.clientX)), true);
    }
    rail.addEventListener('pointerup', end);
    rail.addEventListener('pointercancel', end);
    sts.forEach(function (b, k) {
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); freigeben(); goTo(k, true); thumb.focus(); } });
    });
    thumb.addEventListener('keydown', function (e) {
      var k = e.key, n = null;
      if (k === 'ArrowRight' || k === 'ArrowUp' || k === 'PageUp') n = idx + 1;
      else if (k === 'ArrowLeft' || k === 'ArrowDown' || k === 'PageDown') n = idx - 1;
      else if (k === 'Home') n = 0;
      else if (k === 'End') n = N - 1;
      if (n !== null) { e.preventDefault(); freigeben(); goTo(n, true); }
    });

    root._stp = {
      goTo: goTo,
      state: function () {
        return { idx: idx, user: user, visible: visible,
          paused: vids.map(function (v) { return v ? v.paused : null; }),
          t: vids.map(function (v) { return v ? +v.currentTime.toFixed(2) : null; }),
          src: vids.map(function (v) { return v ? !!v.getAttribute('src') : null; }) };
      }
    };
    setUI(0);
  }

  function alle() { [].forEach.call(document.querySelectorAll('[data-eh-stp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);
})();
